/* eslint-disable no-new */
import EventClass from "common/utils/ui/event-class";

export class Redesign2025Masthead {
  #$selector;

  constructor(options) {
    this.#$selector = options.selector;
  }

  init() {
    new EventClass({
      eventSelector: this.#$selector,
      event: "mouseover",
      eventCallback: Redesign2025Masthead.showMenu
    });

    new EventClass({
      eventSelector: this.#$selector,
      event: "mouseleave",
      eventCallback: Redesign2025Masthead.hideMenu
    });
  }

  static showMenu(event, $target) {
    const { category } = $target.dataset;
    document.querySelector(`[data-menu-category="${category}"]`).classList.remove("hidden");
  }

  static hideMenu(event, $target) {
    const { category } = $target.dataset;
    document.querySelector(`[data-menu-category="${category}"]`).classList.add("hidden");
  }
}

export default () => new Redesign2025Masthead({ selector: ".js-redesign-2025-main-menu" }).init();
